<script>
	import { Authentication } from '../stores';
	
	let username = '';
	let password = '';
	let error = ''

	async function login() {
        const response = await fetch(
            'MYURL/login',
            {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify({
                    'email': username,
                    'password': password
                })
            }
        );
        const result = await response.json();
        
		if ( result['statusCode'] === 200 ) {
            Authentication.set(result['headers'][0].Value[0]);
			if ( error ) error = ''
		}
		else {
			error = 'Fehlerhafte E-Mail und/oder Passwort.'
			console.log("Fehlerhafte E-Mail und/oder Passwort.")
		}
	}

</script>

<form on:submit|preventDefault={login} class="flex mx-auto col-6">
    <div class="center">
	<div class="mb-3">
		<label for="username" class="form-label">E-Mail</label>
		<input type="email" class="form-control" id="username" bind:value={username} />
	</div>

	<div class="mb-3">
		<label for="password" class="form-label">Passwort</label>
		<input type="password" class="form-control" id="password" bind:value={password} />
	</div>

	<button type="submit" class="btn btn-primary">Login</button>
	<div id="error_message" class="text-danger">
		<small>{error}</small>
	</div>
    </div>
</form>

<style>
    .center {
        text-align: center;
    }
</style>